import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { IEntityNode } from 'app/projects/shared/src/lib/interfaces/entity-node.interface';

@Component({
    selector: 'app-course-offering-select-catagories-dialog',
    templateUrl: './course-offering-select-catagories-dialog.component.html',
    styleUrls: ['./course-offering-select-catagories-dialog.component.scss'],
})
export class CourseOfferingSelectCategoriesDialogComponent implements OnInit {
    @Input() listTree: IEntityNode[];
    @Input() title: string;
    @Input() expandFirstItem: boolean = false;
    @Input() selectedCategoriesList: IEntityNode[] = [];
    @Input() isSingleSelect: boolean = false;

    treeControl = new NestedTreeControl<IEntityNode>((node) => node.children);
    dataSource = new MatTreeNestedDataSource<IEntityNode>();
    selectedNode: IEntityNode | null = null;

    constructor(public dialogRef: MatDialogRef<CourseOfferingSelectCategoriesDialogComponent>) {}

    ngOnInit(): void {
        this.dataSource.data = this.listTree;
        if (this.expandFirstItem) {
            this.treeControl.expand(this.listTree[0]);
        }

        if (this.selectedCategoriesList?.length) {
            this.markSelectedNodes(this.dataSource.data, this.selectedCategoriesList);
        }
    }

    private markSelectedNodes(nodes: IEntityNode[], selectedNodes: IEntityNode[]): void {
        nodes.forEach((node) => {
            if (selectedNodes.some((sel) => String(sel.id) === String(node.id))) {
                node.isSelected = true;
            }
            if (node.children?.length) {
                this.markSelectedNodes(node.children, selectedNodes);
            }
        });
    }

    private findNodeById(nodes: IEntityNode[], id: string | number): IEntityNode | null {
        for (const node of nodes) {
            if (String(node.id) === String(id)) {
                return node;
            }
            if (node.children?.length) {
                const found = this.findNodeById(node.children, id);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    }

    hasChild = (_: number, node: IEntityNode) => !!node.children && node.children.length > 0;

    onSelect(node: IEntityNode): void {
        if (this.isSingleSelect) {
            if (this.selectedNode && this.selectedNode !== node) {
                this.selectedNode.isSelected = false;
            }

            node.isSelected = true;
            this.selectedNode = node;
        } else {
            node.isSelected = !node.isSelected;

            if (node.isSelected) {
                this.selectedCategoriesList.push(node);
            } else {
                this.selectedCategoriesList = this.selectedCategoriesList.filter((item) => String(item.id) !== String(node.id));
            }
        }
    }

    onDeselect(node: IEntityNode): void {
        const treeNode = this.findNodeById(this.dataSource.data, node.id) || node;
        treeNode.isSelected = false;

        if (this.isSingleSelect) {
            this.selectedNode = null;
        } else {
            this.selectedCategoriesList = this.selectedCategoriesList.filter((item) => String(item.id) !== String(node.id));
        }
    }

    onClearSelection(): void {
        if (this.isSingleSelect && this.selectedNode) {
            this.onDeselect(this.selectedNode);
        } else {
            this.selectedCategoriesList.forEach((selected) => {
                const treeNode = this.findNodeById(this.dataSource.data, selected.id);
                if (treeNode) {
                    treeNode.isSelected = false;
                }
            });
            this.selectedCategoriesList = [];
        }
    }

    removeFromList(category: IEntityNode): void {
        this.onDeselect(category);
    }

    onSave(): void {
        if (this.isSingleSelect) {
            this.dialogRef.close(this.selectedNode);
        } else {
            this.dialogRef.close(this.selectedCategoriesList);
        }
    }
}
